<template>
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_742_56197)">
      <circle
        cx="13.7227"
        cy="14.293"
        r="13"
        fill="#FFC847"
      />
      <rect
        width="20.622"
        height="3.12043"
        transform="translate(3.96484 20.4727)"
        fill="#EE3B3B"
      />
      <path
        d="M21.8144 20.5379L6.82037 20.6283L6.78906 13.1641L7.38171 10.0868L10.1009 7.88046L14.0402 6.98047L18.0145 7.85139L20.8382 9.94162L21.6749 12.3802L21.8144 20.5379Z"
        fill="#FFAA33"
      />
      <path
        d="M17.0546 9.9361C16.8407 9.79788 16.5524 9.85142 16.4082 10.0564C16.264 10.2614 16.3198 10.5377 16.5337 10.6759C17.9755 11.612 18.8405 13.1628 18.8405 14.8254C18.8405 15.0705 19.0497 15.271 19.3055 15.271C19.5612 15.271 19.7705 15.0705 19.7705 14.8254C19.7707 12.8644 18.7521 11.0371 17.0546 9.93598L17.0546 9.9361Z"
        fill="#28293D"
        stroke="#28293D"
        stroke-width="0.2"
        stroke-linejoin="round"
      />
      <path
        d="M15.3343 9.15998C14.7763 9.00404 14.1995 8.92383 13.6134 8.92383C13.3577 8.92383 13.1484 9.12435 13.1484 9.36946C13.1484 9.61456 13.3577 9.81509 13.6134 9.81509C14.1112 9.81509 14.604 9.88187 15.0739 10.0156C15.1157 10.029 15.1623 10.0335 15.2041 10.0335C15.404 10.0335 15.5901 9.90873 15.6506 9.71268C15.7203 9.47634 15.5807 9.23123 15.3343 9.15999L15.3343 9.15998Z"
        fill="#28293D"
        stroke="#28293D"
        stroke-width="0.2"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.73018 24.6319H26.6936C26.9931 24.6319 27.2363 24.3988 27.2363 24.1119C27.2363 23.8249 26.9931 23.5918 26.6936 23.5918H1.73018C1.43074 23.5918 1.1875 23.8249 1.1875 24.1119C1.1875 24.3988 1.43074 24.6319 1.73018 24.6319Z"
        fill="#28293D"
        stroke="#28293D"
        stroke-width="0.2"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.5243 20.8501C24.5243 20.5632 24.2811 20.3301 23.9816 20.3301H4.44503C4.14558 20.3301 3.90234 20.5632 3.90234 20.8501V24.112C3.90234 24.3989 4.14558 24.6321 4.44503 24.6321H23.9816C24.2811 24.6321 24.5243 24.3989 24.5243 24.112V20.8501ZM4.98771 21.3702V23.5919H23.4389V21.3702H4.98771Z"
        fill="#28293D"
        stroke="#28293D"
        stroke-width="0.2"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.3544 13.2482C22.3544 9.4524 18.7097 6.375 14.2142 6.375H14.2132C9.71814 6.375 6.07422 9.45198 6.07422 13.2471V20.9131C6.07422 21.166 6.31746 21.3714 6.6169 21.3714H21.812C22.1115 21.3714 22.3547 21.166 22.3547 20.9131L22.3544 13.2482ZM21.2691 20.4549V13.2482C21.2691 9.95827 18.1106 7.29142 14.2142 7.29142H14.2132C10.3173 7.29142 7.15959 9.95785 7.15959 13.2471V20.4549H21.2691Z"
        fill="#28293D"
        stroke="#28293D"
        stroke-width="0.2"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.99872 4.06001L6.91771 5.89839C7.12945 6.10132 7.47347 6.10132 7.68497 5.89839C7.89671 5.69547 7.89671 5.36579 7.68497 5.1631L5.76666 3.32407C5.55443 3.12114 5.21089 3.12114 4.99865 3.32407C4.78691 3.52745 4.78691 3.85667 4.99865 4.06007L4.99872 4.06001Z"
        fill="#28293D"
        stroke="#28293D"
        stroke-width="0.2"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.6552 3.32413L20.7369 5.16316C20.5252 5.36608 20.5252 5.69577 20.7369 5.89845C20.9487 6.10137 21.2927 6.10137 21.5042 5.89845L23.4232 4.06007C23.6349 3.85669 23.6349 3.52747 23.4232 3.32407C23.211 3.12114 22.8674 3.12114 22.6552 3.32407L22.6552 3.32413Z"
        fill="#28293D"
        stroke="#28293D"
        stroke-width="0.2"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.7533 3.82941V1.22906C14.7533 0.942089 14.5101 0.708984 14.2107 0.708984C13.9112 0.708984 13.668 0.942089 13.668 1.22906V3.82941C13.668 4.11638 13.9112 4.34949 14.2107 4.34949C14.5101 4.34949 14.7533 4.11638 14.7533 3.82941Z"
        fill="#28293D"
        stroke="#28293D"
        stroke-width="0.2"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.76925 12.671H4.48266C4.78211 12.671 5.02535 12.4379 5.02535 12.1509C5.02535 11.864 4.78211 11.6309 4.48266 11.6309H1.76925C1.4698 11.6309 1.22656 11.864 1.22656 12.1509C1.22656 12.4379 1.4698 12.671 1.76925 12.671Z"
        fill="#28293D"
        stroke="#28293D"
        stroke-width="0.2"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.0192 12.671H26.7327C27.0321 12.671 27.2753 12.4379 27.2753 12.1509C27.2753 11.864 27.0321 11.6309 26.7327 11.6309H24.0192C23.7198 11.6309 23.4766 11.864 23.4766 12.1509C23.4766 12.4379 23.7198 12.671 24.0192 12.671Z"
        fill="#28293D"
        stroke="#28293D"
        stroke-width="0.2"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_742_56197">
        <rect
          width="28"
          height="28"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
